import React, { Component } from 'react';
import axios from "axios";
import { ConfigContext } from "../Context/ConfigContext";
import { NavLink, Link } from 'react-router-dom';


class Header extends Component {
  static contextType = ConfigContext;

  constructor(props) {
    super(props);
    this.state = {
      employeeInfo: [],
      modules: [],
      loadingList: true,
      showMyLeaves: false,
      showMyLeavesSandBox: false,
      showPayslip: false,
      showTeamLeaves: false,
      showTeamLeavesBalance: false,
      showTeamAttendance: false,
      showMyTeamAttendance: false,
      showSalaryDetails: false,
      showLetters: false,
      showDocuments: false,
      showOverTime: false,
      showPMS: false,
      showResignation: false,
    };
  }

  componentDidMount() {
    this.setState({ loadingList: true }, () => {
      this.GetList();
      this.GetModules();
    })
  }

  GetList = () => {
    const { apiURL, apiHeaderJSON, employee_id } = this.context;
    const headers = apiHeaderJSON;

    axios.get(`${apiURL}Home/GetProfile?employee_id=${employee_id}`, { headers }).then((response) => {
      const data = response.data.data;

      if (response.data.success === true) {
        this.setState({
          employeeInfo: data.employee,
        });
      } else {
        this.setState({ loadingList: false });
      }
    });
  };
  GetModules = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}User/GetModules`, { headers })
      .then((response) => {
        const data = response.data.data;
        console.log(`data`, data);
        if (response.data.success === true) {
          this.setState({ modules: data, loadingList: false }, this.showModule);
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  showModule = () => {
    const { modules } = this.state;
    let showMyLeaves = false;
    let showMyLeavesSandBox = false;
    let showTeamLeaves = false;
    let showTeamAttendance = false;
    let showMyTeamAttendance = false;
    let showSalaryDetails = false;
    let showLetters = false;
    let showDocuments = false;
    let showOverTime = false;
    let showPayslip = false;
    let showPMS= false;
    let showResignation= false;

    modules.forEach((module) => {
      if (module.module === 'leaves' && module.module_status === 1) {
        showMyLeaves = true;
        showTeamLeaves = true;
      } 
      else if (module.module === 'leaves_pluse' && module.module_status === 1) {
        showMyLeavesSandBox = true;
      } 
      else if (module.module === 'attendance' && module.module_status === 1) {
        showTeamAttendance = true;
        showMyTeamAttendance = true;
        showOverTime = true;
      } 
      else if (module.module === 'salary_details' && module.module_status === 1) {
        showSalaryDetails = true;
        showLetters = true;
      } else if (module.module === 'documents' && module.module_status === 1) {
        showDocuments = true;
      }
      else if (module.module === "payslip" && module.module_status === 1) {
        showPayslip = true;
      }
      else if (module.module === "pms" && module.module_status === 1) {
        showPMS = true;
      }
      else if (module.module === "resignation" && module.module_status === 1) {
        showResignation = true;
      }
    });

    this.setState({
      showMyLeaves,
      showMyLeavesSandBox,
      showTeamLeaves,
      showTeamAttendance,
      showMyTeamAttendance,
      showSalaryDetails,
      showLetters,
      showDocuments,
      showPayslip,
      showOverTime,
      showPMS,
      showResignation,
    });
  };
  render() {
    const { loadingList, showMyLeaves, showMyLeavesSandBox, showTeamLeaves, showTeamAttendance, showMyTeamAttendance, showSalaryDetails, showLetters, showDocuments, employeeInfo, showOverTime, showPayslip, showPMS, showResignation } = this.state;

    if (loadingList) {
      return <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    }

    const handleLogout = () => {
      localStorage.removeItem("token_emp");
      localStorage.removeItem("company_id_emp");
      localStorage.removeItem("employee_id_emp");
      localStorage.removeItem("employee_code_emp");
      localStorage.removeItem("induction_status");
      window.location.href = '/'
    };
    return (
      <div>
        <header id="page-topbar">
          <div className="layout-width">
            <div className="navbar-header">
              <div className="d-flex">
                {/* LOGO */}
                <div className="navbar-brand-box horizontal-logo">
                  <NavLink to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                        alt=""
                        height={72}
                      />
                    </span>
                    <span className="logo-lg">
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`}
                        alt=" "
                        height={80}
                      />
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}assets/talentco-new-logo.png`}
                        alt=""
                        height={100}
                      />
                    </span>
                  </NavLink>
                  <a href="index.html" className="logo logo-light">
                    <span className="logo-sm">
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                        alt=""
                        height={22}
                      />
                    </span>
                    <span className="logo-lg">
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                        alt=""
                        height={17}
                      />
                    </span>
                  </a>
                </div>
                <button
                  type="button"
                  className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                  id="topnav-hamburger-icon"
                >
                  <span className="hamburger-icon">
                    <span />
                    <span />
                    <span />
                  </span>
                </button>
                {/* App Search*/}
                {/* <form className="app-search d-none d-md-block">
                  <div className="position-relative mt-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      autoComplete="off"
                      id="search-options"
                    />
                    <span className="mdi mdi-magnify search-widget-icon" />
                    <span
                      className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                      id="search-close-options"
                    />
                  </div>
                  <div
                    className="dropdown-menu dropdown-menu-lg"
                    id="search-dropdown"
                  >
                    <div data-simplebar style={{ maxHeight: "320px" }}>
                     
                      <div className="dropdown-header">
                        <h6 className="text-overflow text-muted mb-0 text-uppercase">
                          Recent Searches
                        </h6>
                      </div>
                      <div className="dropdown-item bg-transparent text-wrap">
                        <a
                          href="index.html"
                          className="btn btn-soft-secondary btn-sm rounded-pill"
                        >
                          how to setup <i className="mdi mdi-magnify ms-1" />
                        </a>
                        <a
                          href="index.html"
                          className="btn btn-soft-secondary btn-sm rounded-pill"
                        >
                          buttons <i className="mdi mdi-magnify ms-1" />
                        </a>
                      </div>
                     
                      <div className="dropdown-header mt-2">
                        <h6 className="text-overflow text-muted mb-1 text-uppercase">
                          Pages
                        </h6>
                      </div>
                      
                      <a href={`/`} className="dropdown-item notify-item">
                        <i className="ri-bubble-chart-line align-middle fs-18 text-muted me-2" />
                        <span>Analytics Dashboard</span>
                      </a>
                      
                      <a href={`/`} className="dropdown-item notify-item">
                        <i className="ri-lifebuoy-line align-middle fs-18 text-muted me-2" />
                        <span>Help Center</span>
                      </a>
                      
                      <a href={`/`} className="dropdown-item notify-item">
                        <i className="ri-user-settings-line align-middle fs-18 text-muted me-2" />
                        <span>My account settings</span>
                      </a>
                     
                      <div className="dropdown-header mt-2">
                        <h6 className="text-overflow text-muted mb-2 text-uppercase">
                          Members
                        </h6>
                      </div>
                      <div className="notification-list">
                        
                        <a href={`/`} className="dropdown-item notify-item py-2">
                          <div className="d-flex">
                            <img
                              src={`${process.env.REACT_APP_BASE_URL}assets/images/users/avatar-2.jpg`}
                              className="me-3 rounded-circle avatar-xs"
                              alt="user-pic"
                            />
                            <div className="flex-grow-1">
                              <h6 className="m-0">Angela Bernier</h6>
                              <span className="fs-11 mb-0 text-muted">
                                Manager
                              </span>
                            </div>
                          </div>
                        </a>
                        
                        <a href={`/`} className="dropdown-item notify-item py-2">
                          <div className="d-flex">
                            <img
                              src={`${process.env.REACT_APP_BASE_URL}assets/images/users/avatar-3.jpg`}
                              className="me-3 rounded-circle avatar-xs"
                              alt="user-pic"
                            />
                            <div className="flex-grow-1">
                              <h6 className="m-0">David Grasso</h6>
                              <span className="fs-11 mb-0 text-muted">
                                Web Designer
                              </span>
                            </div>
                          </div>
                        </a>
                       
                        <a href={`/`} className="dropdown-item notify-item py-2">
                          <div className="d-flex">
                            <img
                              src={`${process.env.REACT_APP_BASE_URL}assets/images/users/avatar-5.jpg`}
                              className="me-3 rounded-circle avatar-xs"
                              alt="user-pic"
                            />
                            <div className="flex-grow-1">
                              <h6 className="m-0">Mike Bunch</h6>
                              <span className="fs-11 mb-0 text-muted">
                                React Developer
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="text-center pt-3 pb-1">
                      <a
                        href="pages-search-results.html"
                        className="btn btn-primary btn-sm"
                      >
                        View All Results
                        <i className="ri-arrow-right-line ms-1" />
                      </a>
                    </div>
                  </div>
                </form> */}
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <div className="dropdown d-md-none topbar-head-dropdown header-item">
                  <button
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                    id="page-header-search-dropdown"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="bx bx-search fs-22" />
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                    aria-labelledby="page-header-search-dropdown"
                  >
                    <form className="p-3">
                      <div className="form-group m-0">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search ..."
                            aria-label="Recipient's username"
                          />
                          <button className="btn btn-primary" type="submit">
                            <i className="mdi mdi-magnify" />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="dropdown ms-sm-3 header-item topbar-user">
                  <button
                    type="button"
                    className="btn"
                    id="page-header-user-dropdown"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="d-flex align-items-center">
                      <img
                        className="rounded-circle header-profile-user"
                        src={`${process.env.REACT_APP_BASE_URL}assets/profile-pic.png`}
                        alt="Header Avatar"
                      />
                      <span className="text-start ms-xl-2">
                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text"
                          style={{ width: 100, overflow: 'hidden', textWrap: 'nowrap', textOverflow: 'ellipsis' }}>
                          {employeeInfo.employee_name}
                        </span>
                        {/* <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                          candidate
                        </span> */}
                      </span>
                    </span>
                  </button>
                  <div className="dropdown-menu">
                    {/* item*/}
                    <h6 className="dropdown-header">
                    <span className=" d-xl-inline-block ms-1 fw-bold fw-medium user-name-text"
                        style={{ maxWidth: "500px", textWrap: "wrap" }}>
                        {employeeInfo.employee_code}
                      </span><br/>
                      <div className="dropdown-divider" />
                      <span className=" d-xl-inline-block ms-1 fw-medium user-name-text"
                        style={{ maxWidth: "500px", textWrap: "wrap" }}>
                        {employeeInfo.employee_name}
                      </span>
                      
                    </h6>
                    {/* <a className="dropdown-item" href="pages-profile.html"><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" /> <span className="align-middle">Profile</span></a>
                  <a className="dropdown-item" href="apps-chat.html"><i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1" /> <span className="align-middle">Messages</span></a>
                  <a className="dropdown-item" href="apps-tasks-kanban.html"><i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1" /> <span className="align-middle">Taskboard</span></a>
                  <a className="dropdown-item" href="pages-faqs.html"><i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1" /> <span className="align-middle">Help</span></a> */}
                    <div className="dropdown-divider" />
                    {/* <a className="dropdown-item" href="pages-profile.html"><i className="mdi mdi-wallet text-muted fs-16 align-middle me-1" /> <span className="align-middle">Balance : <b>$5971.67</b></span></a>
                  <a className="dropdown-item" href="pages-profile-settings.html"><span className="badge bg-success-subtle text-success mt-1 float-end">New</span><i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1" /> <span className="align-middle">Settings</span></a>
                  <a className="dropdown-item" href="auth-lockscreen-basic.html"><i className="mdi mdi-lock text-muted fs-16 align-middle me-1" /> <span className="align-middle">Lock screen</span></a> */}
                    <button style={{ width:"90%"}} className="dropdown-item m-auto border border-danger rounded-3" onClick={handleLogout}>
                      <i className="mdi mdi-logout text-danger fs-16 align-middle me-1" /> 
                      <span className="align-middle text-danger" data-key="t-logout">Logout</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* removeNotificationModal */}
        <div
          id="removeNotificationModal"
          className="modal fade zoomIn"
          tabIndex={-1}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="NotificationModalbtn-close"
                />
              </div>
              <div className="modal-body">
                <div className="mt-2 text-center">
                  <lord-icon
                    src="https://cdn.lordicon.com/gsqxdxog.json"
                    trigger="loop"
                    colors="primary:#f7b84b,secondary:#f06548"
                    style={{ width: "100px", height: "100px" }}
                  />
                  <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4>Are you sure ?</h4>
                    <p className="text-muted mx-4 mb-0">
                      Are you sure you want to remove this Notification ?
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                  <button
                    type="button"
                    className="btn w-sm btn-light"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn w-sm btn-danger"
                    id="delete-notification"
                  >
                    Yes, Delete It!
                  </button>
                </div>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
        {/* /.modal */}
        {/* ========== App Menu ========== */}
        {localStorage.getItem("induction_status")==="0"?
        null:
        <div className="app-menu navbar-menu">
          <div className="navbar-brand-box">
            <a href="index.html" className="logo logo-dark">
              <span className="logo-sm">
                <img src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-sm.png`} alt="" height={22} />
              </span>
              <span className="logo-lg">
                <img src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-dark.png`} alt="" height={17} />
              </span>
            </a>
            <a href="index.html" className="logo logo-light">
              <span className="logo-sm">
                <img src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-sm.png`} alt="" height={22} />
              </span>
              <span className="logo-lg">
                <img src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-light.png`} alt="" height={17} />
              </span>
            </a>
            <button
              type="button"
              className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
              id="vertical-hover"
            >
              <i className="ri-record-circle-line" />
            </button>
          </div>
          <div id="scrollbar">
            <div className="container-fluid">
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <li className="menu-title">
                  <span data-key="t-menu">Menu</span>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link menu-link"
                    data-bs-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="sidebarMyDetails"
                  >
                    <i className="ri-dashboard-2-line" />
                    <span data-key="t-dashboards">My Details</span>
                  </button>
                  <div className="collapse menu-dropdown" id="sidebarMyDetails">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link to="/" className="nav-link" data-key="t-overview">Overview</Link>
                      </li>
                      {showMyTeamAttendance && (
                        <li className="nav-item"><a href="#sidebarEmail" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarEmail" data-key="t-email">Attendance</a>
                          <div className="collapse menu-dropdown" id="sidebarEmail">
                              <ul className="nav nav-sm flex-column">
                              {showTeamAttendance && <li className="nav-item"><NavLink to={`MyAttendance`} className="nav-link" data-key="t-mailbox">My Attendance</NavLink></li>} 
                              {showTeamAttendance && <li className="nav-item"><NavLink to={`MyRegularization`} className="nav-link" data-key="t-mailbox">My Regularization</NavLink></li>}   
                              {showTeamAttendance && <li className="nav-item"><NavLink to={`MyAttendanceReport`} className="nav-link" data-key="t-mailbox">My Attendance Report</NavLink></li>}  
                              </ul>
                            </div>
                        </li>
                      )}
                      
                      {showSalaryDetails && (
                        <li className="nav-item">
                          <Link to="/SalaryDetails" className="nav-link" data-key="t-salary">Salary Details</Link>
                        </li>
                      )}
                      {showLetters && (
                        <li className="nav-item">
                          <Link to="/Letters" className="nav-link" data-key="t-letters">Letters</Link>
                        </li>
                      )}
                      {showDocuments && (
                        <li className="nav-item">
                          <Link to="/Documents" className="nav-link" data-key="t-documents">Documents</Link>
                        </li>
                      )}
                      {showMyLeaves && (
                        <li className="nav-item">
                          <Link to="/MyLeaves" className="nav-link" data-key="t-leaves">My Leaves</Link>
                        </li>
                      )}
                      {showMyLeavesSandBox && (
                        <li className="nav-item">
                          <Link to="/MyLeavesSandBox" className="nav-link" data-key="t-leaves">My Leaves</Link>
                        </li>
                      )}
                      {/* {showOverTime && (
                        <li className="nav-item">
                          <Link to="/OverTime" className="nav-link" data-key="t-overtime">Over Time</Link>
                        </li>
                      )} */}
                      {showPMS && (
                        <li className="nav-item">
                          <Link to="/MyGoals" className="nav-link" data-key="t-overtime">My Goals</Link>
                        </li>
                      )}
                      <li className="nav-item">
                        <Link to="/MyExpense" className="nav-link" data-key="t-overtime">My Expense</Link>
                      </li>
                      {/* {showTeamAttendance && (
                        <li className="nav-item">
                          <Link to="/MyAttendance" className="nav-link" data-key="t-attendance">My Attendance</Link>
                        </li>
                      )}
                      {showTeamAttendance && (
                        <li className="nav-item">
                          <Link to="/MyRegularization" className="nav-link" data-key="t-attendance">My Regularization</Link>
                        </li>
                      )}
                      {showTeamAttendance && (
                        <li className="nav-item">
                          <Link to="/MyAttendanceReport" className="nav-link" data-key="t-attendance">My Attendance Report</Link>
                        </li>
                      )} */}
                      {showPayslip && (
                        <li className="nav-item">
                          <Link to="/MyPayslip" className="nav-link" data-key="t-attendance">My Payslip</Link>
                        </li>
                      )}
                      {showMyLeavesSandBox && (
                        <li className="nav-item">
                          <Link to="/PaySlipSandbox" className="nav-link" data-key="t-attendance">My Payslip</Link>
                        </li>
                      )}
                      {showResignation && (
                        <li className="nav-item">
                          <Link to="/MyResignation" className="nav-link" data-key="t-attendance">My Resignation</Link>
                        </li>
                      )}
                      
                    </ul>
                  </div>
                </li>
                {(showTeamLeaves || showMyTeamAttendance) && (
                  <li className="nav-item">
                    <button
                      className="nav-link menu-link"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="sidebarMyTeam"
                    >
                      <i className="ri-apps-2-line" />
                      <span data-key="t-my-team">My Team</span>
                    </button>
                    <div className="collapse menu-dropdown" id="sidebarMyTeam">
                      <ul className="nav nav-sm flex-column">
                     
                      <li className="nav-item">
                            <Link to="/TeamEmployees" className="nav-link" data-key="t-approve-leave">Team Employees</Link>
                      </li>
                      {showPMS && (
                        <li className="nav-item"><a href="#sidebarEmail" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarEmail" data-key="t-email">PMS</a>
                          <div className="collapse menu-dropdown" id="sidebarEmail">
                              <ul className="nav nav-sm flex-column">
                                <li className="nav-item"><NavLink to={`GoalsMaster`} className="nav-link" data-key="t-mailbox">Goals Master</NavLink></li>
                                <li className="nav-item"><NavLink to={`AssignGoals`} className="nav-link" data-key="t-mailbox">Assign Goals</NavLink></li>
                                <li className="nav-item"><NavLink to={`GoalReview`} className="nav-link" data-key="t-mailbox">Goal Review </NavLink></li>
                              </ul>
                            </div>
                        </li>
                      )}
                      
                         
                        {/* {showTeamLeaves && ( old leave module
                          <li className="nav-item">
                            <Link to="/TeamLeaves" className="nav-link" data-key="t-approve-leave">Team Leaves</Link>
                          </li>
                        )} */}
                      {showTeamAttendance && (
                        <li className="nav-item"><a href="#sidebarEmail" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarEmail" data-key="t-email">Team Attendance</a>
                          <div className="collapse menu-dropdown" id="sidebarEmail">
                              <ul className="nav nav-sm flex-column">
                                {showMyTeamAttendance && <li className="nav-item"><NavLink to={`TeamRegularization`} className="nav-link" data-key="t-mailbox">Team Regularization</NavLink></li>}
                                {showMyTeamAttendance && <li className="nav-item"><NavLink to={`TeamAttendanceReport`} className="nav-link" data-key="t-mailbox">Team Attendance Report</NavLink></li>}
                              </ul>
                            </div>
                        </li>
                      )}
                      
                      {(showTeamLeaves || showMyLeavesSandBox) && (
                        <li className="nav-item"><a href="#sidebarEmail" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarEmail" data-key="t-email">Team Leaves</a>
                          <div className="collapse menu-dropdown" id="sidebarEmail">
                            <ul className="nav nav-sm flex-column">
                              {showTeamLeaves && <li className="nav-item"><NavLink to={`TeamLeaves`} className="nav-link" data-key="t-mailbox">Team Leaves</NavLink></li>}
                              {showMyLeavesSandBox && <li className="nav-item"><NavLink to={`TeamsLeavesSandBox`} className="nav-link" data-key="t-mailbox">Team Leaves</NavLink></li>}
                              {(showTeamLeaves || showMyLeavesSandBox) && <li className="nav-item"><NavLink to={`TeamLeavesBalance`} className="nav-link" data-key="t-mailbox">Team Leaves Balance</NavLink></li>}
                            </ul>
                          </div>
                        </li>
                      )}
                       <li className="nav-item">
                            <Link to="/TeamExpense" className="nav-link" data-key="t-approve-leave">Team Expense</Link>
                      </li>
                       {showResignation && (
                        <li className="nav-item">
                            <Link to="/TeamsResignation" className="nav-link" data-key="t-approve-leave">Team Resignation</Link>
                      </li>
                       )}
                      
                        {/* {showTeamLeaves && (
                          <li className="nav-item">
                            <Link to="/TeamsLeavesSandBox" className="nav-link" data-key="t-approve-leave">Team Leaves</Link>
                          </li>
                        )}
                        <li className="nav-item">
                            <Link to="/TeamLeavesBalance" className="nav-link" data-key="t-approve-leave">Team Leaves Balance</Link>
                          </li> */}
                        {/* {showMyTeamAttendance && (
                          <li className="nav-item">
                            <Link to="/TeamRegularization" className="nav-link" data-key="t-team-regularization">Team Regularization</Link>
                          </li>
                        )}
                        {showMyTeamAttendance && (
                          <li className="nav-item">
                            <Link to="/TeamAttendanceReport" className="nav-link" data-key="t-team-regularization">Team Attendance Report</Link>
                          </li>
                        )} */}
                      </ul>
                    </div>
                  </li>
                )}
              </ul>
            </div>

          </div>
          <div className="sidebar-background" />
        </div>}
        
        <div className="vertical-overlay" />
      </div>
    );
  }
};

export default Header;
